"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	adult: "Adulte",
	animals: "Animaux",
	achitecture_design: "Architecture & Design",
	beauty: "Beaut\xE9",
	wellness_health: "Bien \xEAtre et sant\xE9",
	business: "Business",
	culture: "Culture (Art, litt\xE9rature...)",
	education_knowledge: "Education et Savoirs",
	entertainment: "Divertissement (cin\xE9ma, TV...)",
	family: "Famille",
	food_drinks: "Food & Drinks",
	gaming: "Gaming",
	humor: "Humour",
	lifestyle: "Inspiration & Lifestyle",
	creative_hoobies: "DIY",
	luxury: "Luxe",
	mode_accessories: "Mode & accessoires",
	music: "Musique",
	nature_environment: "Nature & Environnement",
	news: "News & Tendances",
	politic: "Politique",
	science: "Science",
	social: "Social et solidaire",
	sport_fitness: "Sport & Fitness",
	tech: "Tech",
	vehicules: "V\xE9hicules",
	traval: "Voyage",
	photography: "Photographie",
	reality_show: "T\xE9l\xE9r\xE9alit\xE9"
};